import { render, staticRenderFns } from "./ListFavoris.vue?vue&type=template&id=4278b101&scoped=true&"
import script from "./ListFavoris.vue?vue&type=script&lang=js&"
export * from "./ListFavoris.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4278b101",
  null
  
)

export default component.exports